import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "panel"]

  connect() {
    this.close()
  }

  toggle() {
    const expanded = this.panelTarget.classList.contains("hidden")
    this.panelTarget.classList.toggle("hidden", !expanded)
    this.buttonTarget.setAttribute("aria-expanded", String(expanded))
  }

  close() {
    this.panelTarget.classList.add("hidden")
    this.buttonTarget.setAttribute("aria-expanded", "false")
  }
}
